import axiosRequest from '../axios-config';
import { getCookie } from 'cookies-next';

export const getRelatedInfo = async (sku) => {
  const config = {
    method: 'get',
    url: `/product/relatedInfo/${sku}`,
  };
  try {
    const req = await axiosRequest(config);
    return req?.data;
  } catch (error) {
    return error;
  }
};

export const getProductsBySkus = async ({ skuBulk, page = 0 }) => {
  // const handshake = getCookie('handshake');
  const transformSKus = skuBulk
    ? skuBulk.map((sku) => 'sku=' + sku).join('&')
    : '';

  const config = {
    method: 'get',
    url: `/search/product?${transformSKus}&pageNo=${page}`,
  };

  // if (selectedAtteributes) {
  //   const atterbiutes = selectedAtteributes
  //     .map((select) => 'select=' + select)
  //     .join('&');
  //   config.url += `&${atterbiutes}`;
  // }
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

export const getProductsBySkusV2 = async ({ locale, skuBulk, page = 0 }) => {
  const transformSKus = skuBulk
    ? skuBulk.map((sku) => 'sku=' + sku).join('&')
    : '';

  const config = {
    baseURL: process.env.NEXT_PUBLIC_API_BASEURL.replace('v1', 'v2'),
    method: 'get',
    url: `/search/product/skus/${locale}?${transformSKus}&pageNo=${page}`,
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

export const notifyWhenAvailableProduct = async (userId, entity_id) => {
  const handshake = getCookie('handshake');
  const config = {
    method: 'get',
    url: `/mstore/notify-me/customer/${userId}/product/${entity_id}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

export const getRelatedProducts = async (sku) => {
  const config = {
    method: 'get',
    url: `/customer/amasty_mostviewed_related_products?sku=${sku}`,
  };
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};
